import styled from 'styled-components';

export const GridStyled = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  padding: 0 15px;
  margin: 0 auto;

  @media screen and (min-width: 992px) {
    max-width: 1200px;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 15px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Grid/styled.js